<template>
  <div>
    <div id="body">
      <div class="wrapper">
        <div class="web-site">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/policy/list' }">
              行业洞察
            </el-breadcrumb-item>
            <el-breadcrumb-item
              v-if="type > 0 && type < 4"
              :to="{ path: '/news/list?filterTab=' + type + '&keyword=' }"
            >
              {{
                type == 1
                  ? "数据快递"
                  : type == 2
                  ? "国内经济"
                  : type == 3
                  ? "国际动态"
                  : ""
              }}
            </el-breadcrumb-item>
            <el-breadcrumb-item>{{ model.title }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="18">
            <div class="detail">
              <div class="dbox">
                <div class="dbox_content" v-loading="loading">
                  <div class="detail-info">
                    <div class="name">{{ model.title }}</div>
                    <div class="time">
                      <span>
                        <img src="~@/assets/images/icon-time.png" alt="" />
                        {{ dateFormat(model.publishTime, "YYYY/MM/DD") }}
                      </span>
                    </div>
                    <div class="op">
                      <!-- <el-button type="info" round size="mini">
                        <i class="el-icon-star-off"></i>
                        <i class="el-icon-star-on"></i>收藏
                      </el-button> -->
                      <el-button
                        type="info"
                        round
                        size="mini"
                        @click="shareConfig.show = !shareConfig.show"
                      >
                        <i class="el-icon-share"></i>分享
                      </el-button>
                    </div>
                    <share
                      v-if="shareConfig.show"
                      :config="shareConfig"
                      style="
                        position: absolute;
                        right: 0;
                        margin-top: 10px;
                        background: #fff;
                      "
                    ></share>
                    <div class="info">
                      <span v-if="model.source && model.source.length > 0">
                        <strong>来源：</strong>
                        {{ model.source ? model.source.join(" ") : "" }}
                      </span>
                      <span
                        class="block"
                        v-if="model.keyword && model.keyword.length > 0"
                      >
                        <strong>关键字：</strong>
                        {{ model.keyword ? model.keyword.join(" ") : "" }}
                      </span>
                      <span class="block" v-if="model.sourceUrl">
                        <strong>原文链接：</strong>
                        <el-link target="_blank" :href="model.sourceUrl">
                          {{ model.sourceUrl }}
                        </el-link>
                      </span>
                    </div>
                  </div>
                  <div class="detail-content" v-html="model.content"></div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="6">
            <div class="dbox about">
              <div class="dbox_title">
                <h4>相关预览</h4>
              </div>
              <div class="dbox_content">
                <div class="text-list">
                  <ul v-loading="recommendLoading">
                    <li v-for="(item, index) in recommendList" :key="index">
                      <el-link
                        :href="'/news/detail?id=' + item.Id + '&type=' + type"
                        v-html="item.title"
                      ></el-link>
                      <span class="time">
                        {{ dateFormat(item.publishTime, "YYYY/MM/DD") }}
                      </span>
                      <span class="from">
                        {{ item.source ? item.source.join(" ") : "" }}
                      </span>
                    </li>
                  </ul>

                  <div
                    class="no-data"
                    v-if="!recommendList || recommendList.length === 0"
                  >
                    <div class="tip">
                      <svg
                        t="1626241932884"
                        class="icon"
                        viewBox="0 0 1428 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="2321"
                        width="60"
                        height="60"
                      >
                        <path
                          d="M982.129778 353.975309H572.833185C556.689383 353.975309 543.604938 339.854222 543.604938 322.37037s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 290.765432 1011.358025 304.886519 1011.358025 322.37037S998.286222 353.975309 982.117136 353.975309M982.129778 467.753086H572.833185C556.689383 467.753086 543.604938 453.632 543.604938 436.148148s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 404.54321 1011.358025 418.664296 1011.358025 436.148148S998.286222 467.753086 982.117136 467.753086M805.293827 594.17284H572.681481c-16.080593 0-29.076543-14.121086-29.076543-31.604939s12.995951-31.604938 29.076543-31.604938h232.612346c16.080593 0 29.076543 14.121086 29.076543 31.604938S821.37442 594.17284 805.293827 594.17284"
                          p-id="2322"
                        ></path>
                        <path
                          d="M501.304889 173.675457c-12.995951 0-23.627852 10.49284-23.627852 23.400296v743.626272c0 12.894815 10.631901 23.387654 23.640494 23.387654h602.895802c13.033877 0 23.640494-10.49284 23.640494-23.387654V197.075753c0-12.894815-10.606617-23.387654-23.640494-23.387654h-602.895802zM1104.225975 1024H501.304889C454.934123 1024 417.185185 986.642963 417.185185 940.689383V197.088395C417.185185 151.122173 454.934123 113.777778 501.304889 113.777778h602.921086C1150.622025 113.777778 1188.345679 151.134815 1188.345679 197.088395v743.600988c0 45.95358-37.723654 83.310617-84.119704 83.310617z"
                          p-id="2323"
                        ></path>
                        <path
                          d="M1216.840691 910.222222h-68.54479v-59.897679h68.54479c13.451062 0 24.778272-10.214716 24.778272-22.287802V82.17284c0-12.073086-11.32721-22.287802-24.778272-22.287803H616.245728c-13.451062 0-24.778272 10.214716-24.778271 22.287803v65.068246H530.962963V82.17284C530.962963 36.851358 569.21758 0 616.245728 0h600.594963C1263.86884 0 1302.123457 36.851358 1302.123457 82.185481V828.049383C1302.123457 873.370864 1263.86884 910.222222 1216.840691 910.222222"
                          p-id="2324"
                        ></path>
                        <path
                          d="M1399.049481 910.222222H1192.555457C1176.247309 910.222222 1163.061728 896.088494 1163.061728 878.617284s13.18558-31.604938 29.493729-31.604938h206.494024c16.308148 0 29.493728 14.133728 29.493729 31.604938s-13.18558 31.604938-29.493729 31.604938M514.528395 1024H281.916049c-16.080593 0-29.076543-14.133728-29.076543-31.604938s12.995951-31.604938 29.076543-31.604939h232.612346c16.080593 0 29.076543 14.133728 29.076543 31.604939S530.608988 1024 514.528395 1024M173.372049 1024H28.899556C12.920099 1024 0 1009.866272 0 992.395062S12.920099 960.790123 28.899556 960.790123h144.472493C189.351506 960.790123 202.271605 974.923852 202.271605 992.395062S189.351506 1024 173.372049 1024M326.580148 50.567901h-58.987457C259.451259 50.567901 252.839506 44.904296 252.839506 37.925926s6.611753-12.641975 14.753185-12.641975h58.987457C334.72158 25.283951 341.333333 30.947556 341.333333 37.925926s-6.611753 12.641975-14.753185 12.641975"
                          p-id="2325"
                        ></path>
                        <path
                          d="M290.765432 88.493827c-6.97837 0-12.641975-6.611753-12.641975-14.753185V14.753185C278.123457 6.611753 283.787062 0 290.765432 0s12.641975 6.611753 12.641975 14.753185v58.987457C303.407407 81.882074 297.743802 88.493827 290.765432 88.493827M273.901037 480.395062h-67.407012C197.176889 480.395062 189.62963 471.924938 189.62963 461.432099s7.547259-18.962963 16.864395-18.962963h67.407012c9.317136 0 16.864395 8.470123 16.864395 18.962963s-7.547259 18.962963-16.864395 18.962963"
                          p-id="2326"
                        ></path>
                        <path
                          d="M233.876543 505.679012c-10.49284 0-18.962963-7.547259-18.962963-16.864395v-67.407012c0-9.317136 8.470123-16.864395 18.962963-16.864395s18.962963 7.547259 18.962963 16.864395v67.407012c0 9.317136-8.470123 16.864395-18.962963 16.864395M132.740741 142.222222a28.444444 28.444444 0 1 0 0.025284 56.914173 28.444444 28.444444 0 0 0-0.025284-56.914173m0 85.333334A56.952099 56.952099 0 0 1 75.851852 170.666667C75.851852 139.289284 101.363358 113.777778 132.740741 113.777778s56.888889 25.511506 56.888889 56.888889-25.511506 56.888889-56.888889 56.888889M1384.296296 231.765333a14.791111 14.791111 0 0 0-14.753185 14.753186 14.791111 14.791111 0 0 0 14.753185 14.753185 14.791111 14.791111 0 0 0 14.753185-14.753185 14.791111 14.791111 0 0 0-14.753185-14.753186m0 59.000099c-24.399012 0-44.246914-19.847901-44.246913-44.246913s19.847901-44.246914 44.246913-44.246914 44.246914 19.847901 44.246914 44.246914-19.847901 44.246914-44.246914 44.246913"
                          p-id="2327"
                        ></path>
                      </svg>
                      <div class="text">暂无数据</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { axiosRequest, axiosOptions } from "../../util/request";
import moment from "moment";

export default {
  data() {
    return {
      loading: false,
      id: this.$route.query.id,
      type: this.$route.query.type || 1,
      model: {},
      shareConfig: {
        show: false,
        sites: ["qzone", "qq", "weibo", "wechat", "douban"],
        wechatQrcodeTitle: "微信扫一扫：分享",
        wechatQrcodeHelper:
          "<p>打开微信，点击底部的“发现”，</p><p>使用“扫一扫”即可分享网页。</p>",
      },
      recommendLoading: true,
      recommendList: [],
    };
  },
  created() {
    this.getDetail().then(() => {
      this.getRecommend();
    });
  },
  mounted() {},
  methods: {
    async getDetail() {
      if (this.id) {
        this.loading = true;
        await axiosRequest(
          "/search/news-detail",
          { id: this.id },
          axiosOptions("post", "", "json")
        )
          .then((res) => {
            this.loading = false;
            if (res.data && res.data.code === 200) {
              this.model = res.data.data;
            }
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    getRecommend() {
      let keyword = "";
      if (this.model.keyword && this.model.keyword.length > 0) {
        keyword = this.model.keyword.join(";");
      }

      if (keyword) {
        axiosRequest(
          "/search/news-recommend",
          { keyword: keyword, type: this.type },
          axiosOptions("post", "", "json")
        )
          .then((res) => {
            this.recommendLoading = false;
            if (res.data && res.data.code === 200) {
              res.data.data.forEach((element) => {
                if (element && element.Id !== this.id) {
                  this.recommendList.push(element);
                }
              });
            }
          })
          .catch(() => {
            this.recommendLoading = false;
          });
      } else {
        this.recommendLoading = false;
      }
    },
    dateFormat(cellValue, format) {
      if (!cellValue) return "";

      return moment(cellValue).format(format);
    },
  },
};
</script>
<style>
.detail-content p.paper_num {
  display: none;
}
</style>
<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "~@/assets/css/detail.scss";
@import "../../assets/share/share.css";
.detail-info {
  margin-bottom: 30px;
  padding-left: 0;
  height: auto;
  .time {
    font-size: 14px;
    color: #9da7c1;
    img {
      margin-right: 5px;
      vertical-align: -2px;
    }
  }
  .info {
    margin: 20px -3px 0;
    padding: 13px 15px;
    font-size: 0;
    border: 1px solid #dee3ed;
    > span {
      display: inline-block;
      min-width: 33.333%;
      font-size: 14px;
      margin-right: 0;
      padding: 5px 20px;
      line-height: 20px;
      background: url(~@/assets/images/icon-tag.png) no-repeat left 7px;
      vertical-align: top;
      &.block {
        display: block;
      }
      img {
        margin-right: 5px;
        vertical-align: -2px;
      }
    }
    strong {
      color: #333333;
    }
  }
  .op {
    left: auto;
    right: 0;
    bottom: auto;
    margin-top: -23px;
    .el-button {
      width: 64px;
      height: 24px;
      color: #9f9f9f;
      padding: 0;
      line-height: 24px;
      font-size: 14px;
      //background-color: #f1f2f3;
      background-color: #fff;
      border: 0;
    }
  }
}
.detail-content {
  font-size: 18px;
  line-height: 36px;
  text-align: justify;
  ::v-deep {
    h1,
    h2,
    h3,
    h4 {
      font-size: 1.2em;
      font-weight: normal;
      margin-bottom: 1.5em;
    }
    p {
      //text-indent: 2em;
      margin-bottom: 1.5em;
    }
  }
}
@media screen and (max-width: 768px) {
  .detail-info {
    .name {
      height: auto;
      -webkit-line-clamp: unset;
    }
    .info {
      position: static;
      margin: 20px 0 0;
    }
  }
  .detail-content {
    font-size: 14px;
    line-height: 2;
  }
  .text-list li a {
    font-size: 14px;
  }
}
</style>
